var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTime(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 36 36",
    width: 36,
    height: 36,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#A)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.166 24.25l-5.916-5.916V8.274h1.5v9.44l5.475 5.475-1.06 1.06zM3 21.774h9.75v1.5H3v-1.5zm-3-4.5h9.75v1.5H0v-1.5zm3-4.5h9.75v1.5H3v-1.5zm18 20.25a15.04 15.04 0 0 1-13.059-7.613l1.303-.74a13.54 13.54 0 0 0 11.757 6.853 13.52 13.52 0 0 0 13.5-13.5 13.52 13.52 0 0 0-13.5-13.5 13.54 13.54 0 0 0-11.747 6.835l-1.303-.74a15.03 15.03 0 0 1 13.05-7.594c8.27 0 15 6.73 15 15s-6.73 15-15 15z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "A"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h36v36H0z"
  })))));
}

export default __webpack_public_path__ + "media/c419bbb6.svg";
export { SvgTime as ReactComponent };